// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-fa-six-digits-input__name[data-v-2a31b2d6]{margin-bottom:20px}.two-fa-six-digits-input__inputs[data-v-2a31b2d6]{display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
